import "../../../App.css";
import { DashBoardLayout } from "../../Dashboard/Layout/DashBoardLayout";
import ProfileHero from "../ProfileHero";
import ArrowRight from "../../EducationPins/imagesEducation/educationArrowRight.svg";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { ContextProvider } from "../../Context";
import { Modal } from "../../Screens/Modal/Modal";
import cameraProfile from "../ProfileImages/cameraProfile.svg";
import galleryProfile from "../ProfileImages/galleryProfile.svg";
import closeCircle from "../../EducationPins/imagesEducation/close-circle.svg";
import { GetLocalStorage } from "../../LocalStorage/LocalStorage";
import { UserBgFormatting } from "../../ProfileImageModule";
export default function EditProfile() {
  const { openImage, setOpenImage,
     isDarkMode,
      customerDetail, 
      progressTaskBarResponse } = useContext(ContextProvider);
  const {phone, email, full_name} = customerDetail;
  const UserIcon = localStorage.getItem("UserIcon")
const Data = GetLocalStorage();
  const UserData = Data?.aremxyUsername?.toString();
const bgUsername = UserBgFormatting(UserData);
  return (
    <div>
      <DashBoardLayout>
        <div className="flex flex-col justify-between md:h-[1000px] h-[900px] pb-[20%]">
          <div className="">
            <ProfileHero />
            <div className="flex flex-col gap-[20px] md:gap-[30px] lg:gap-[40px]">
              {/* Edit Profile */}
              <div className="flex lg:gap-[10px] gap-[5.87px] ">
                <h2
                  className={`text-[#7C7C7C] font-[500] text-[12px] leading-[10.4px] md:text-[11.736px] md:leading-[18px] lg:text-[20px] lg:leading-[30px] ${
                    isDarkMode ? "text-white" : ""
                  }`}
                >
                  Edit Profile
                </h2>
                <img
                  className="lg:h-[24px] lg:w-[24px] md:h-[14.083px] md:w-[14.083px] self-center"
                  src={ArrowRight}
                  alt=""
                />
              </div>
              {/* EDIT PROFILE PIC */}
              <div className="flex md:justify-start my-10 justify-center gap-[7.042px] lg:gap-[12px]">
            <div className={`${bgUsername} bg-opacity-10`}>
                  <img
                    src={UserIcon}
                    className="h-[48px] w-[46.753px] rounded-[48px]
      lg:h-[150px] lg:w-[150px] 
      md:h-[88.801px]  md:w-[88.801px]

      md:rounded-[88.201px] lg:rounded-[150px]"
                    alt="profilePic"
                  />
                  </div>
                
                
                {/* Profile text */}
                <div className="flex flex-col justify-center  gap-[3.52px] lg:gap-[12px]">
              <div className="flex gap-2 items-center">
                  <p
                 className={`text-[#7E7E7E] text-[12px] leading-[18px] md:text-[12.042px] md:leading-[16px] lg:text-[16px] lg:leading-[24.8px] ${
                    isDarkMode ? "text-white" : "text-black"
                  }`}>
                    {full_name ? full_name : Data?.UserFullName}
                  </p>
                   {progressTaskBarResponse?.data?.data?.beta === true && (
                <p className="text-[11px] md:text-[12px] text-[#7109d3] w-[60px]
                rounded-[5px] px-0.5 py-[3px] bg-[#f5ecfd] text-center leading-[14px] 
                lg:leading-[15px] lg:py-[5px]   lg:w-[80px] font-bold">
                  Beta
                </p>
              )}
                  </div>
                  <p
                  className={`text-[#7E7E7E] text-[12px] leading-[18px] md:text-[12.042px] md:leading-[16px] lg:text-[16px] lg:leading-[24.8px] ${
                    isDarkMode ? "text-white" : "text-black"
                  }`}
                  >
                    {email ? email : Data.UserEmail}
                  </p>
                </div>
              </div>
              {/* CHANGE EMAIL AND PHONE NUMBERS */}
              <div
                className="flex flex-col gap-[20px]
        md:flex md:flex-row  md:gap-[12.91px] lg:gap-[22px] w-[100%]"
              >
                {/* SELECT EMAIL CHANGE */}
                <div
                  className="flex flex-col w-full md:w-1/2 
gap-[25px] lg:gap-[15px] cursor-default lg:mb-[26px] md:mb-[15.26px] mb-[20px]"
                >
                  <h2
                    className={`text-[ font-[600] text-[13px] leading-[10.4px] md:text-[9.389px] md:leading-[12.206px]
     lg:text-[16px] lg:leading-[20.8px] ${isDarkMode ? "text-white" : "text-black"}`}
                  >
                    Email
                  </h2>
               
                  <input
                    type="email"
                    name=""
                    id=""
                    readOnly
                   className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`} 
                    value ={email ? email : Data.UserEmail}
                  />
                  <Link
                    to="/ChangeEmail"
                    className="lg:w-[163px] md:w-[150px] w-[100%]"
                  >
                    <button
                      className="w-[100%] text-[12px] leading-[18px]
      md:text-[9.389px]  md:leading-[14px] md:py-[10px]
         md:rounded-[12px] rounded-[4.241px]
       font-[600] lg:text-[16px] lg:leading-[24px]
       bg-[#04177F] py-[12px]
       text-white text-center"
                    >
                      Change Email
                    </button>
                  </Link>
                </div>

                {/* SELECT PHONE NUMBER CHANGE */}
                <div
                  className="flex flex-col w-full md:w-1/2
gap-[25px] lg:gap-[10px] cursor-default"
                >
             <h2
        className={` font-[600] text-[13px] leading-[10.4px] md:text-[9.389px] md:leading-[12.206px]
       lg:text-[16px] lg:leading-[20.8px] ${isDarkMode ? "text-white" : "text-black"}`}>
                    Phone Number
                  </h2>
                  {/* <div
                    className="flex  items-center md:h-[40px] h-[30px]
      lg:h-[51px] pl-[5.586px] lg:pl-[10px] 
      border-[0.4px] border-[#9C9C9C] 
     border-[solid] lg:mb-[26px] md:mb-[15.26px] mb-[20px]"
                  >
                    <p
                      className="font-[500] text-[#7E7E7E] 
      text-[8px] leading-[10.4px]
      md:text-[9.389px] md:leading-[12.206px]
     lg:text-[16px] lg:leading-[20.8px] cursor-default"
                    >
                      09087654321
                    </p>
                  </div> */}
                  <input
                    type="email"
                    name=""
                    id=""
                    className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`} 
                    value = {phone  ? phone : Data.UserPhone}
                  />
                  <Link
                    to="/ChangePhoneNumber"
                    className="lg:w-[163px] md:w-[150px] w-[100%]"
                  >
                    <button
                      className="w-[100%] text-[12px] leading-[18px] md:text-[9.389px]  md:leading-[14px]
   md:rounded-[12px] rounded-[4.241px] 
       font-[600] lg:text-[16px] lg:leading-[24px]
      bg-[#04177F] md:py-[10px] py-[12px]
       text-white text-center"
                    >
                      Change Phone No
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {/* CONTACT US */}
          <div
            className=" flex gap-[8.729px]  md:gap-[14.896px] 
     justify-center px-[8.594px]  lg:pt-[20%] lg:pb-[20%] md:pt-[100%] md:pb-[30%] pt-[40%] pb-[30%]"
          >
            <p
              className={`font-[500] text-[12px]  
              leading-[10.4px] lg:text-[16px] lg:leading-[15.6px] md:leading-[12.938px] self-center ${isDarkMode ? "text-white" : "text-black"}`}
            >
              You need help?
            </p>
            <Link
              to="/contactUs"
              className="font-[500] text-white text-[12px]  py-[8px] px-[10.594px] leading-[10.4px] rounded-[5.156px] bg-[#04177F] lg:text-[12px] lg:leading-[14.4px] md:py-[4.865px] md:px-[14.594px] md:leading-[5.985px] lg:py-[10px] lg:px-[16px] lg:rounded-[9px]"
            >
              Contact Us
            </Link>
          </div>
        </div>
        {openImage && (
          <Modal>
            <div
              className="mx-[19px] md:mx-[0px] flex flex-col lg:w-[40%] 
            md:w-[50%] w-[100%]  md:h-[404px] 
            h-[237.07px] bg-white rounded-[8px]
            lg:rounded-[12px] shadow-[0px_0px_11.73611px_0px_rgba(0,0,0,0.25)]
 lg:shadow-[0px_0px_20px_0px_rgba(0,0,0,0.25)]"
            >
              {/* CANCEL ICON */}
              <div
                onClick={() => {
                  setOpenImage(false);
                }}
                className=" flex justify-end p-[10px]"
              >
                <img
                  className="lg:h-[32px] w-[32px] cursor-pointer"
                  src={closeCircle}
                  alt=""
                />
              </div>
              <div
                className="flex justify-center items-center w-[100%] h-[100%] 
         lg:gap-[69px] md:gap-[30px] gap-[40.49px]"
              >
                {/* CAMERA SELECTION */}
                <div className="flex flex-col md:gap-[11px] gap-[6.45px]  cursor-pointer">
                  <img
                    className="lg:p-[41.5px] p-[25.23px] bg-[#F4F4F4] border-[1px]
                 border-[#9C9C9C]  
                rounded-full md:shadow-2xl"
                    src={cameraProfile}
                    alt=""
                  />
                  <h2
                    className="text-center  font-[400] text-[8px] leading-[12px] 
                lg:text-[16px] lg:leading-[24px] "
                  >
                    Camera
                  </h2>
                </div>
                {/* GALLERY SELECTION*/}
                <div className="flex flex-col md:gap-[11px] gap-[6.45px]  cursor-pointer">
                  <img
                    className="lg:p-[41.5px]  p-[25.23px] bg-[#F4F4F4] border-[1px]
                 border-[#9C9C9C]    
                 rounded-full md:shadow-2xl"
                    src={galleryProfile}
                    alt=""
                  />
                  <h2
                    className="text-center font-[400] text-[8px] leading-[12px] 
                lg:text-[16px] lg:leading-[24px]"
                  >
                    Gallery
                  </h2>
                </div>
              </div>
            </div>
          </Modal>
        )}
      </DashBoardLayout>
    </div>
  );
}
